export const api = 'https://api.barcelonabridalweek.com/v1/graphql'  

import axios from 'axios'
import VueJwtDecode from 'vue-jwt-decode'
// axios.defaults.headers.common['x-hasura-admin-secret'] = 'gHHdxsykQrqZc6rF'
//'Authorization': 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InNvcG9ydGUuY2xpZW50ZXNAZmlyYWJhcmNlbG9uYS5jb20iLCJpZCI6NDQsImV4aGliaXRvcl9pZCI6bnVsbCwicm9sZSI6Imdyb3VwMCIsInNkYSI6dHJ1ZSwiYWNjb3VudF9pZCI6MzgsImJyYW5kX2lkIjpudWxsLCJpYXQiOjE2MDAxMDk1NTEsImV4cCI6MTYwMjcwMTU1MX0.Irl2ycpyg7cOwJ6nKhG1PVyCEIJL-93anaNQTR4fmls'

const loginMutation = {
	login: `
		mutation Login($email: String!, $locator: String!) {
          login(email: $email, locator: $locator) {
            expiresIn
            accessToken
            refresh_token
          }
        }
	`,
	getBrands: `
		query getBrandsByExhibitorId($exhibitor_id: String!) {
		  brands(where: {exhibitor_id: {_eq: $exhibitor_id}}) {
		    id
		    name
		  }
		}
	`
}

export async function userLogin(mail,loc){
	let response = {}
	let results = {}
	let out = {}
	
	response = await axios.post(api, {
		query: loginMutation.login,
		variables: {
			email: mail,
			locator: loc
		}

	})
	//console.log("userLogin",response)
	results = response.data
	
	if (!results.hasOwnProperty('errors')){
		let tmp = VueJwtDecode.decode(results.data.login.accessToken)
		out.success = true
		out.exhibitorId = tmp.exhibitor_id
		out.accessToken = results.data.login.accessToken
	}else{
		out.success = false
		out.errorMessage = results.errors[0].message
	}
	return out
}

export async function getBrands(exhibitorId,access_token){
	let response = {}
	let results = {}
	
	response = await axios.post(api, {
		query: loginMutation.getBrands,
		variables: {
			exhibitor_id: exhibitorId
		}

	},{
	  headers: {
	    'Authorization': `token ${access_token}`
	  }
	})
	//console.log("getBrands",response)
	results = response.data.data.brands

	return results
}
